/** Organization name used in legal documents. */
export const LEGAL_ORGANIZATION_NAME = 'Bethlehem Homeschool Group';

export const LEGAL_ORGANIZATION_SHORT = 'BHG';

/** Host church that provides meeting facilities; not the operator of the co-op website. */
export const LEGAL_CHURCH_NAME = 'Bethlehem Baptist Church';

/** Physical location referenced in policies. */
export const LEGAL_ADDRESS_LINE =
  'Bethlehem Baptist Church, 8400 Poole Road, Knightdale, North Carolina 27545';

/**
 * Fallback director contact when App Settings → Director email is empty.
 * Prefer setting the director email in App Settings (super admin).
 */
export const LEGAL_CONTACT_EMAIL_DEFAULT = 'director@bethlehemhomeschool.group';

/** Version date shown at top of Terms and Privacy (ISO date). Update when policies change materially. */
export const LEGAL_LAST_UPDATED = 'August 29, 2026';

export const TERMS_OF_SERVICE_PATH = '/terms';

export const PRIVACY_POLICY_PATH = '/privacy';

/** Element id on the landing page footer — scroll target when returning from legal pages. */
export const LANDING_SITE_FOOTER_ID = 'site-footer';

/** `location.state.from` when user opened Terms/Privacy from the landing footer. */
export const LEGAL_RETURN_FROM_LANDING_FOOTER = 'landing-footer';
